import { dispatchPromise } from './action-helpers';

import { createTempId } from '../utils/helpers';
import { getCurrentUserId } from '../services/store-service';

const DEFAULT_MESSAGE_PROPS = {
    attachments: [],
    author: null,
    chat: undefined,
    message_id: undefined,
    created_at: null,
    doc_id: undefined,
    id: null,
    is_deleted: false,
    is_edited: false,
    repliers: [],
    replies: 0,
    seen_by: [],
    tagged: [],
    hidden: [],
    text: undefined,
    type: null,
    updated_at: null
};

const MAX_MESSAGE_RESPONSE_TIME = 500;
let messageCreateDuration = 200;

export const sendMessage = async (messageProps = {}) => {
    const message = Object.assign({}, DEFAULT_MESSAGE_PROPS, messageProps, {
        id: createTempId(),
        seen_by: [getCurrentUserId()],
        author: getCurrentUserId(),
        created_at: new Date().getTime() + messageCreateDuration,
        updated_at: new Date().getTime() + messageCreateDuration,
        attachments: (messageProps.nifty_files || []).map(id => ({ id }))
    });

    let requestStart;

    if (message.files) {
        message.files.filter(file => (file instanceof File) || file.uri || file.serviceType).forEach(file => {
            dispatchPromise({
                type: 'FILE_UPLOAD_START',
                payload: {
                    file: {
                        size: file.size || file.sizeBytes,
                        name: file.name
                    }
                }
            });
        });
    }

    if (!message.files || !message.files.length) {
        requestStart = Date.now();
    }

    const response = await dispatchPromise({
        type: 'MESSAGE_SEND_REQUESTED',
        payload: { message }
    });

    if (requestStart) {
        messageCreateDuration = Math.min(Date.now() - requestStart, MAX_MESSAGE_RESPONSE_TIME);
    }

    return response;
}

export const fetchMessages = props => {
    return dispatchPromise({
        type: 'MESSAGES_FETCH_REQUESTED',
        payload: { ...props }
    });
}

export const fetchMessage = messageId => {
    return dispatchPromise({
        type: 'MESSAGE_FETCH_REQUESTED',
        payload: { messageId }
    });
}

export const updateMessage = (messageId, messageProps, preventSave) => {
    return dispatchPromise({
        type: 'MESSAGE_UPDATE_REQUESTED',
        preventSave,
        payload: {
            messageId,
            messageProps: {
                ...messageProps,
                is_edited: true
            }
        }
    });
}

export const removeMessage = messageId => {
    return dispatchPromise({
        type: 'MESSAGE_REMOVE_REQUESTED',
        payload: { messageId }
    });
}

export const removeMessages = threadId => {
    return dispatchPromise({
        type: 'MESSAGES_REMOVE_REQUESTED',
        payload: { threadId }
    });
}

export const seeMessage = messageId => {
    return dispatchPromise({
        type: 'MESSAGE_SEE_REQUESTED',
        payload: {
            messageId,
            userId: getCurrentUserId()
        }
    });
}

export const seeMessages = (messagesIds, userId) => {
    return dispatchPromise({
        type: 'MESSAGES_SEE_REQUESTED',
        payload: {
            messages: messagesIds,
            userId
        }
    });
}

export const hearMessage = messageId => {
    return dispatchPromise({
        type: 'MESSAGE_HEAR_REQUESTED',
        payload: {
            messageId,
            userId: getCurrentUserId()
        }
    });
}

export const setMessageReaction = (messageId, reaction) => {
    return dispatchPromise({
        type: 'MESSAGE_SET_REACTION_REQUESTED',
        payload: {
            messageId,
            reaction,
            userId: getCurrentUserId()
        }
    });
}

export const rejectMessage = id => {
    return dispatchPromise({
        type: 'MESSAGE_REJECT',
        payload: { id }
    });
}
